import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
import { PartnerAccountType } from "../../configs/constants";
import { showShareLink } from "../../configs/uri-config-utils";
export const ActiveCustomerMobEmptyStateStack = async (partnerAccountType, user) => {
    const DS = {
        activeCustomerMobEmptyStateStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.XXXXL
            },
            widgetItems: [
                { id: 'activeCustomerMobEmptyStateIcon', type: WIDGET.ICON },
                { id: 'activeCustomerMobEmptyStateStackSpace0', type: WIDGET.SPACE },
                { id: 'activeCustomerMobEmptyStateStackT1', type: WIDGET.TEXT },
                { id: 'activeCustomerMobEmptyStateStackSpace1', type: WIDGET.SPACE },
                { id: 'activeCustomerMobEmptyStateStack1', type: WIDGET.STACK },
                { id: 'activeCustomerMobEmptyStateStackSpace2', type: WIDGET.SPACE },
                { id: 'activeCustomerMobEmptyStateStack2', type: WIDGET.STACK },
            ]
        },
        activeCustomerMobEmptyStateStack2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 386,
            widgetItems: [
                showShareLink(user) ? { id: 'activeCustomerMobEmptyState_ShareUniqueLinkMobStack', type: WIDGET.STACK } : {},
                (partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL) ? { id: 'activeCustomerMobEmptyStateStack2Space0', type: WIDGET.SPACE } : {},
                (partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL) ? { id: 'activeCustomerMobEmptyState_RegisterLeadsMobStack', type: WIDGET.STACK } : {},
            ]
        },
        activeCustomerMobEmptyState_ShareUniqueLinkMobStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'activeCustomerMobEmptyState_hareUniqueLinkMobBtn', type: WIDGET.BUTTON }
            ]
        },
        activeCustomerMobEmptyState_RegisterLeadsMobStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'activeCustomerMobEmptyState_RegisterLeadsMobBtn', type: WIDGET.BUTTON }
            ]
        },
        activeCustomerMobEmptyState_hareUniqueLinkMobBtn: {
            type: ButtonTypeTokens.MediumSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Share unique link',
            fontSize: FontSizeTokens.XS,
            action: {
                type: ACTION.SHARE_LINK_REF,
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                payload: {}
            }
        },
        activeCustomerMobEmptyState_RegisterLeadsMobBtn: {
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Register customer',
            fontSize: FontSizeTokens.XS,
            action: {
                routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
                type: ACTION.ON_REGISTER_LEADS,
                payload: {}
            }
        },
        activeCustomerMobEmptyStateIcon: {
            name: IconTokens.List,
            size: IconSizeTokens.XXXXXXXXL,
        },
        activeCustomerMobEmptyStateStack1: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            maxWidth: 386,
            padding: {
                top: SizeTypeTokens.MD,
                bottom: SizeTypeTokens.MD,
                left: SizeTypeTokens.LG,
                right: SizeTypeTokens.LG
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2
            },
            bgColor: ColorTokens.Grey_Milk,
            widgetItems: [
                { id: 'activeCustomerMobEmptyStateStack1T1', type: WIDGET.TEXT }
            ]
        },
        activeCustomerMobEmptyStateStack1T1: {
            label: partnerAccountType && partnerAccountType === PartnerAccountType.AFFILIATE ? `Invite your customers and help them fulfill short-term cash needs without selling securities.` : 'Stop redemptions and retain your AUM by educating your customers about loan against mutual funds',
            fontWeight: "400",
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            lineHeight: 18
        },
        activeCustomerMobEmptyStateStackT1: {
            label: 'No completed application found',
            fontWeight: "600",
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24
        },
        activeCustomerMobEmptyStateStackSpace0: {
            size: SizeTypeTokens.MD
        },
        activeCustomerMobEmptyStateStackSpace1: {
            size: SizeTypeTokens.XL
        },
        activeCustomerMobEmptyStateStackSpace2: {
            size: SizeTypeTokens.XL
        },
        activeCustomerMobEmptyStateStack2Space0: {
            size: SizeTypeTokens.XL
        },
    };
    return DS;
};
